module.exports = "<nuc-navigation></nuc-navigation>\n<div class=\"thingsCompContents clearfix\">\n\t<router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/things/things.component.html
// module id = 1488
// module chunks = 0